export const API_URL = process.env.REACT_APP_API_URL;
export const GOOGLE_MAP_API_KEY = "AIzaSyBtCCY3PsVFDSCE8Q1WuIDzK4IltMZh2Is";
